(function () {
  // Diego:
  // Mobile (≤749px) → todos los botones al 90vw, centrados al viewport.
  // Desktop (>749px) → todos los botones con el mismo width que "PERSONALIZAR EL MÍO" (botón de la garantía).

  var PROPS_MANAGED = [
    'display', 'width', 'min-width', 'max-width',
    'margin-left', 'margin-right', 'align-self',
    'align-items', 'justify-content', 'text-align',
    'box-sizing', 'min-height', 'padding', 'flex',
    'position', 'left', 'right', 'transform'
  ];

  var PARENT_PROPS_TO_RESTORE = ['padding-left', 'padding-right', 'align-items'];

  function shouldSkip(btn) {
    return btn.closest(
      '.card, .card-wrapper, .product-card, .product-card-wrapper, ' +
      'form, .quick-add, .header, .header-wrapper, ' +
      '.menu-drawer, .utility-bar, .footer, .cart-drawer, .cart, .checkout'
    );
  }

  function resetBtn(btn) {
    PROPS_MANAGED.forEach(function (prop) {
      btn.style.removeProperty(prop);
    });
  }

  function resetParents(btn) {
    var iwtContent = btn.closest('.image-with-text__content');
    if (iwtContent) PARENT_PROPS_TO_RESTORE.forEach(function (p) { iwtContent.style.removeProperty(p); });
    var iwtTextItem = btn.closest('.image-with-text__text-item');
    if (iwtTextItem) PARENT_PROPS_TO_RESTORE.forEach(function (p) { iwtTextItem.style.removeProperty(p); });
  }

  function applyMobileBtn(btn) {
    btn.style.setProperty('display', 'flex', 'important');
    btn.style.setProperty('width', '90vw', 'important');
    btn.style.setProperty('min-width', '90vw', 'important');
    btn.style.setProperty('max-width', '90vw', 'important');
    btn.style.setProperty('margin-left', 'auto', 'important');
    btn.style.setProperty('margin-right', 'auto', 'important');
    btn.style.setProperty('align-self', 'center', 'important');
    btn.style.setProperty('align-items', 'center', 'important');
    btn.style.setProperty('justify-content', 'center', 'important');
    btn.style.setProperty('text-align', 'center', 'important');
    btn.style.setProperty('box-sizing', 'border-box', 'important');
    btn.style.setProperty('min-height', '48px', 'important');
    btn.style.setProperty('padding', '14px 24px', 'important');
    btn.style.setProperty('flex', '0 0 auto', 'important');

    // Image-with-text: quitar padding del padre + align center
    var iwtContent = btn.closest('.image-with-text__content');
    if (iwtContent) {
      iwtContent.style.setProperty('padding-left', '0', 'important');
      iwtContent.style.setProperty('padding-right', '0', 'important');
      iwtContent.style.setProperty('align-items', 'center', 'important');
    }
    var iwtTextItem = btn.closest('.image-with-text__text-item');
    if (iwtTextItem) {
      iwtTextItem.style.setProperty('padding-left', '0', 'important');
      iwtTextItem.style.setProperty('padding-right', '0', 'important');
    }
  }

  function applyDesktopBtn(btn, refWidth) {
    btn.style.setProperty('width', refWidth + 'px', 'important');
    btn.style.setProperty('min-width', refWidth + 'px', 'important');
    btn.style.setProperty('max-width', refWidth + 'px', 'important');
    btn.style.setProperty('display', 'inline-flex', 'important');
    btn.style.setProperty('align-items', 'center', 'important');
    btn.style.setProperty('justify-content', 'center', 'important');
    btn.style.setProperty('text-align', 'center', 'important');
    btn.style.setProperty('box-sizing', 'border-box', 'important');
    btn.style.setProperty('flex', '0 0 auto', 'important');
  }

  function getReferenceWidth(buttons) {
    // Botón de referencia: el de la sección Garantía Malcriados
    var ref = null;
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].closest('.malcriados-garantia')) {
        ref = buttons[i];
        break;
      }
    }
    if (!ref) return null;
    var w = ref.getBoundingClientRect().width;
    return w > 0 ? Math.round(w) : null;
  }

  function applyUniformWidth() {
    var isMobile = window.innerWidth <= 749;
    var main = document.querySelector('main');
    if (!main) return;

    var buttons = main.querySelectorAll('a.button, button.button, .button');

    // SIEMPRE resetear primero — garantiza estado limpio antes de medir
    buttons.forEach(function (btn) {
      resetBtn(btn);
      resetParents(btn);
    });

    if (isMobile) {
      buttons.forEach(function (btn) {
        if (shouldSkip(btn)) return;
        applyMobileBtn(btn);
      });
      return;
    }

    // Desktop: medir el botón de referencia (sin overrides aplicados aún)
    var refWidth = getReferenceWidth(buttons);
    if (!refWidth) {
      // Element todavía no renderizado — reintentar
      requestAnimationFrame(applyUniformWidth);
      return;
    }

    buttons.forEach(function (btn) {
      if (shouldSkip(btn)) return;
      applyDesktopBtn(btn, refWidth);
    });
  }

  function init() {
    applyUniformWidth();
    window.addEventListener('resize', applyUniformWidth);
    document.addEventListener('shopify:section:load', applyUniformWidth);
    document.addEventListener('shopify:section:reorder', applyUniformWidth);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
